import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Init_des } from '../../components/Javascript/Init_des'
export const E3 = props => {
  return (
    <>
      <Init_des
      title="SPANADAN"
      date=" December 19-20, 2020"
      village=" Online Ms Team"
        p1="Inspired by the vision of transformational change in rural development, we believe it is vital to keep our spirits high. Having said that, Unnat Bharat Abhiyan IIT Roorkee was up with a series of events: ‘Spandan.’ It is only with women that our society sustains, and that is why we call it: ‘Spandan: Heartbeat of the Society.’"

        p2='‘Women Empowerment’ isn’t something that hasn’t been talked about, but the importance of the issue cannot be undermined in any way. The event will be power-packed with our esteemed Speakers ( "Ms Anuradha Kapoor" and "Mrs Archana Garodia Gupta") & a Self-Defence Camp ( "Ms Varsha Singh").'
      />
    </>
  )
}
